import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ListScoutSports.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const ListScoutSports = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const {slug} = useParams();
    const {sports} = useParams();

    const location = useLocation();
    const path = location.pathname;

    let sport = "Sports";
    let sporturl = "sport";

    if (path.includes("baseball")) {sport = "Baseball"; sporturl = 'baseball'};
    if (path.includes("basketball")) {sport = "Basketball"; sporturl = 'basketball'};
    if (path.includes("football")) {sport = "Football"; sporturl = 'football'};
    if (path.includes("hockey")) {sport = "Hockey"; sporturl = 'hockey'};
    if (path.includes("rugby")) {sport = "Rugby"; sporturl = 'rugby'};
    if (path.includes("soccer")) {sport = "Soccer"; sporturl = 'soccer'};
    if (path.includes("cricket")) {sport = "Cricket"; sporturl = 'cricket'};

    const [isLoading, setIsLoading] = useState(true);

    const [activeScouts, setActiveScouts] = useState([]);

    useEffect(() => {
        Promise.all([ 
            
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    const handleClick = (sporturl,continent) => {
        navigate('/scout-sports/'+sporturl+'/'+continent);
    };

    const handleUSClick = (sporturl) => {
        navigate('/sports_scouts_usmap/'+sporturl);
    };

    // async function getambassadorlist() {
       
    //         try {
    //             const response = await fetch(
    //                 app_url+'ambassador/getambassadorlist',
    //                 {
    //                     method: "GET",
    //                     headers: {
    //                     'Content-Type': 'application/json',
    //                     },              
    //                     body: JSON.stringify({
    //                     page: currentPage,
    //                     pagesize: itemsPerPage,
    //                     // id:continentid
    //           }),
    //                 }
    //             )
    //             const responsedata = await response.json();
    //             if(responsedata.data.msg === "Success") {
    //                 setActiveScouts(responsedata.data.result);
    //             }
    //         } catch (error) {
    //             console.error(error);
    //         }finally {
    //             // Set loading to false after fetch completes (success or error)
    //         }
        
    // }
     

    const doBackAway = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back
        } else {
            navigate('/'); // Fallback to home
        }
    };

        //pagination
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(50);
    
        const startIndex =
            (currentPage - 1) * itemsPerPage;
        const endIndex =
            startIndex + itemsPerPage;
        const currentItems =
            activeScouts.slice(startIndex, endIndex);
    
        function goToNextPage() {
            setCurrentPage(prevPage => prevPage + 1);
        }
    
        function goToPrevPage() {
            setCurrentPage(prevPage => prevPage - 1);
        }
    
        function goToSpecificPage(pageNumber) {
            setCurrentPage(pageNumber);
        }
        function renderPaginationControls() {
            const totalPages = Math.ceil(activeScouts.length / itemsPerPage);

            const goToFirstPage = () => setCurrentPage(1);
            const goToLastPage = () => setCurrentPage(totalPages);

            const maxButtons = 10;
            let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
            let endPage = startPage + maxButtons - 1;

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            const pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            return (
                <div>
                    {activeScouts.length > itemsPerPage && (
                        <div style={{ textAlign: "center" }} className="list-scout-sport-pagination">

                            {/* First + Prev */}
                            {currentPage !== 1 && (
                                <>
                                    <button onClick={goToFirstPage}>« First</button>
                                    <button onClick={goToPrevPage}>‹ Previous</button>
                                </>
                            )}
                            {pageNumbers.map((num) => (
                                <button
                                    key={num}
                                    onClick={() => goToSpecificPage(num)}
                                    style={{
                                        fontWeight: num === currentPage ? "bold" : "normal",
                                        color: num === currentPage ? "#111" : "#2c99d2",
                                    }}
                                >
                                    {num}
                                </button>
                            ))}

                            {/* Next + Last */}
                            {currentPage !== totalPages && (
                                <>
                                    <button onClick={goToNextPage}>Next ›</button>
                                    <button onClick={goToLastPage}>Last »</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }

    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwscout/getscoutsportslist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: currentPage,
            pagesize: itemsPerPage,
            sport:sports
            // id:continentid
              }),
            });
            const data = await response.json();
            setActiveScouts(data.data.result);
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
    }, [currentPage]); // Re-fetch data when these change

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main">
                <Helmet><title>Scouts {sport.toLowerCase()}</title></Helmet>
                
                <div className="center left-center">
                    <div className="list-scout-sport-container">
                       <div style={{textAlign: "right"}}><a onClick={doBackAway}>« Back</a></div>
                            <div>
                                <h1>SMWW Certified {sport} Scouts</h1>
                                <p>Sports Management Worldwide is proud to have SMWW {sport.toLowerCase()} scouts located all over the world. If you are looking for a scouting report, you can <a href="/scouting-requests">request one here</a>.</p>
                                <p>To view our rapidly expanding network of SMWW {sport.toLowerCase()} scouts around the world, click on a continent below. To simply see a listing of all SMWW scouts in all sports, <a href="/scouts">click here</a>.</p>                          
                            </div>
                        
                        <div style={{textAlign: "center", marginBottom:"10px"}} className="list-scout-sports-map">
                            <img
                                src="/basic/web/images/scout/agencyhome-maps2.jpg"
                                alt="World Map"
                                useMap="#Mapu"
                                style={{
                                    width: '100%',
                                    maxWidth: '650px',
                                    height: 'auto'
                                }}
                            />

                            <map id="Mapu" name="Mapu">
                                <area 
                                    coords="4,31,68,90" 
                                    // href="/sports_scouts_usmap/basketball" 
                                    onClick={(e) => {e.preventDefault(); handleUSClick(sporturl);}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="71,91,216,115" 
                                    // href="/sports_scouts_usmap/basketball" 
                                    onClick={(e) => {e.preventDefault(); handleUSClick(sporturl);}} 
                                    shape="rect"
                                /> 
                                <area 
                                    coords="65,8,295,91" 
                                    // href="/scout-sports/basketball/7" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '7');}} 
                                    shape="rect"
                                /> 
                                <area 
                                    coords="78,113,214,153" 
                                    // href="/scout-sports/basketball/1" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '1');}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="154,153,263,282" 
                                    // href="/scout-sports/basketball/2" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '2');}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="307,12,440,98" 
                                    // href="/scout-sports/basketball/3" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '3');}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="440,9,642,186" 
                                    // href="/scout-sports/basketball/4" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '4');}} 
                                    shape="rect"
                                /> 
                                <area 
                                    coords="911,330,1051,440" 
                                    // href="/scout-sports/basketball/6" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '6');}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="539,187,633,265" 
                                    // href="/scout-sports/basketball/6" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '6');}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="289,101,404,254" 
                                    // href="/scout-sports/basketball/5" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '5');}} 
                                    shape="rect" 
                                /> 
                                <area 
                                    coords="395,89,446,146" 
                                    // href="/scout-sports/basketball/4" 
                                    onClick={(e) => {e.preventDefault(); handleClick(sporturl, '4');}} 
                                    shape="rect" 
                                />
                            </map>
                        </div>
                        <div className="mobilemaparea">
                        <div style={{clear:"both"}}>&nbsp;</div>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '1');}}>Scouts in Mexico and the Central Americas</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleUSClick(sporturl);}}>Scouts in US</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '7');}}>Scouts in Canada</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '2');}}>Scouts in South America</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '3');}}>Scouts in Europe</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '4');}}>Scouts in Asia &amp; Middle East</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '5');}}>Scouts in Africa</a></h1>

                        <h1><a href onClick={(e) => {e.preventDefault(); handleClick(sporturl, '6');}}>Scouts in South Pacific</a></h1>
                        </div>
                        <div style={{clear:"both"}}></div>
                        <div className="sport-scout-list-container">
                            <ul>
                                {currentItems.map((scout, index) => (
                                <li key={index}>  
                                    <div className="sct_img">
                                        <a href={scout.url}  target="_blank" rel="noreferrer">
                                            <img
                                                src={scout.image}
                                                alt={scout.name}
                                               
                                            />
                                        </a>
                                    </div> 

                                    <div className="sct_name">
                                        <a href={scout.url}  target="_blank" rel="noreferrer">{scout.name}</a>
                                    </div>

                                    <div className="sct_address">{scout.address}</div>
                                </li>
                                ))}
                            </ul>
                        </div>
                        <div className="view-footer">
                            Displaying {activeScouts ? (1) : (0)} - {activeScouts ? (activeScouts.length) : (0)} of {activeScouts ? (activeScouts.length) : (0)}     
                        </div>
                        <div style={{clear:"both"}}></div>
                        {renderPaginationControls()}
                    </div>
                </div>
                <div className="right" 
                //style={{marginLeft: "0px"}}
                >
                      {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                     {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default ListScoutSports;
